import { useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabase";

export interface VisitedVenue {
  id: string;
  venueId: string;
  venueName: string;
  category: string;
  image: string;
  visitedAt: string;
}

export function useVisitedVenues(userId: string | undefined) {
  const [venues, setVenues] = useState<VisitedVenue[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!userId) { setVenues([]); return; }
    setLoading(true);
    const { data } = await supabase
      .from("visited_venues")
      .select("*")
      .eq("user_id", userId)
      .order("visited_at", { ascending: false });
    if (data) {
      setVenues(data.map((r) => ({
        id: r.id as string,
        venueId: r.venue_id as string,
        venueName: r.venue_name as string,
        category: r.category as string,
        image: r.image as string,
        visitedAt: r.visited_at as string,
      })));
    }
    setLoading(false);
  }, [userId]);

  useEffect(() => { fetch(); }, [fetch]);

  const markVisited = useCallback(async (
    venueId: string,
    venueName: string,
    category: string,
    image: string,
  ) => {
    if (!userId) return;
    await supabase.from("visited_venues").upsert({
      user_id: userId,
      venue_id: venueId,
      venue_name: venueName,
      category,
      image,
      visited_at: new Date().toISOString(),
    }, { onConflict: "user_id,venue_id" });
    await fetch();
  }, [userId, fetch]);

  return { venues, loading, markVisited, refetch: fetch };
}
